    // Rotate .active class across LI children of elements with .switch-active-class
    function initSwitchActiveLists() {
        const lists = document.querySelectorAll('.switch-active-class');
        lists.forEach(list => {
            if (list.dataset.switchInitialized === 'true') return;

            const items = Array.from(list.querySelectorAll('li'));
            if (!items.length) return;

            const speedSec = parseFloat(list.dataset.switchSpeed || '2');
            const intervalMs = Math.max(200, speedSec * 1000);

            let idx = 0;
            items.forEach(li => li.classList.remove('active'));
            items[0].classList.add('active');

            const rotate = () => {
                if (!document.body.contains(list)) return; // element removed
                items[idx].classList.remove('active');
                idx = (idx + 1) % items.length;
                items[idx].classList.add('active');
            };

            const timer = setInterval(rotate, intervalMs);
            list.dataset.switchInitialized = 'true';

            // Cleanup if node removed
            const observer = new MutationObserver(() => {
                if (!document.body.contains(list)) {
                    clearInterval(timer);
                    observer.disconnect();
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        });
    }
